import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CurrencyProvider } from "@/context/CurrencyContext";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import TrackApplication from "@/pages/TrackApplication";
import AdminDashboard from "@/pages/AdminDashboard";
import MemberPortal from "@/pages/MemberPortal";
import CheckScore from "@/pages/CheckScore";
import ScriptRegistry from "@/pages/ScriptRegistry";

const PAGE_TITLES = {
  '/': 'AINAA | Home',
  '/track': 'AINAA | Track',
  '/check-score': 'AINAA | Archive',
  '/portal': 'AINAA | Member',
  '/admin': 'AINAA | Console',
  '/registry': 'AINAA | Registry',
  '/privacy': 'AINAA | Privacy',
  '/terms': 'AINAA | Terms',
  '/contact': 'AINAA | Contact',
  '/thank-you': 'AINAA | Thank You',
};

function ScrollToTopAndTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = PAGE_TITLES[pathname] || 'AINAA';
  }, [pathname]);
  return null;
}

function App() {
  return (
    <CurrencyProvider>
      <div className="App min-h-screen bg-[#EDECEA]">
        <BrowserRouter>
          <ScrollToTopAndTitle />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/track" element={<TrackApplication />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/portal" element={<MemberPortal />} />
            <Route path="/check-score" element={<CheckScore />} />
            <Route path="/registry" element={<ScriptRegistry />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </CurrencyProvider>
  );
}

export default App;
